import React, { useState, useMemo, useCallback } from 'react'
import DataTable from 'react-data-table-component';
import DownloadButton from '../dataOutput/DownloadButton';
import '../../style.css'
import BlupsFilteringPopup from './blupsFilteringPopup';

const paginationComponentOptions = {
    noRowsPerPage: false,
    rowsPerPageText: 'Row per page',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All',
};

function BlupsTable(props) {
    const { data, columns } = props;
    const [selectedRows, setSelectedRows] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const filteredItems = data.filter(item => {
        if (filterText === '') {
            return true;
        }
        else if (!item.NAME) {
            return false;
        }
        else {
            return item.NAME.toLowerCase().includes(filterText.toLowerCase())
        }
    });

    const subHeaderComponentMemo = useMemo(() => {
        return (
            <BlupsFilteringPopup
                label={'Filter'}
                popUpTitle={'Filter BLUPs Data'}
                functions={{ createFilteredOutput: props.functions.createFilteredOutput }}
                name={'filterBlups'}
                options={{}}
                selectedRows={selectedRows}
                data={data}
            ></BlupsFilteringPopup>
        );
    }, [selectedRows]);

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, [])

    return (
        <div>
            {
                (data.length === 0 &&
                    <div className="my-5 mx-3" >
                        <h5>BLUPs Analysis Failed</h5>
                    </div>
                ) ||
                (
                    <div>
                        <DataTable stickyHeader={true}
                            columns={columns.map(column => ({
                                name: column,
                                selector: row => row[column],
                                sortable: true,
                                wrap: true
                            }))}
                            data={filteredItems}
                            pagination
                            paginationPerPage={6}
                            paginationRowsPerPageOptions={[6, 10, 15, 20]}
                            paginationComponentOptions={paginationComponentOptions}
                            subHeader
                            subHeaderComponent={subHeaderComponentMemo}
                            selectableRows
                            onSelectedRowsChange={handleRowSelected}
                        />
                        <DownloadButton data={filteredItems} columns={columns} />
                    </div>
                )
            }

        </div>

    );
};

export default BlupsTable;